import React from "react";
import { Paper, makeStyles } from "@material-ui/core";
import Loading from "./loading.gif";

const useStyles = makeStyles(() => ({
    loading: {
        padding: "2ex 0",
        textAlign: "center",
    },
}));

export function LoadingCell() {
    const styles = useStyles();
    return (
        <Paper className={styles.loading}>
            <img src={Loading} width="48" height="48" />
        </Paper>
    );
}
